import s from './ResponseList.module.css';
import { ResponseItemProps } from '@/types/components/responseList';
import { useRouter } from 'next/router';

function ResponseItem({
    response,
    selectedResponseId,
    interactive,
}: ResponseItemProps) {
    const router = useRouter();
    const getLanguage = router.locale ? router.locale : 'nl';

    function customDate(response: string) {
        const userDate = new Date(response);
        const monthName = userDate.toLocaleString('default', {
            month: 'short',
        });
        const sentence =
            userDate.getDate() +
            ' ' +
            monthName +
            ' ' +
            userDate.getHours() +
            ':' +
            (userDate.getMinutes() < 10 ? '0' : '') +
            userDate.getMinutes();

        return sentence;
    }
    const visible =
        !interactive ||
        selectedResponseId == 0 ||
        selectedResponseId == response?.id
            ? ''
            : 'responseItem--hidden';
    return (
        <>
            {response?.id ? (
                <>
                    <button
                        className={`responseItem ${s['responseItem']} ${s['responseItem--selected']} ${s[visible]}`}
                        id={`repsonse_${response.id}`}
                        data-responseid={response.id}
                        aria-describedby={'responsetooltip' + response.id}
                        aria-current={
                            selectedResponseId == response?.id
                                ? 'true'
                                : 'false'
                        }>
                        {response.locationName && (
                            <span className={s['responseItem__Location']}>
                                {response.locationName}
                            </span>
                        )}

                        <div className={s['responseItem__clientBlock']}>
                            <div className={s['responseItem_header']}>
                                <div className={s['responseItem__name']}>
                                    {response.name}
                                </div>
                                <div className={s['responseItem__date']}>
                                    {customDate(response.createdAt)}
                                </div>
                            </div>

                            {response.visible && (
                                <blockquote
                                    className={s['responseItem__quote']}>
                                    {response.mood == 'zorg' ? (
                                        <img
                                            alt={response.mood}
                                            src="/img/zorgSVG.svg"
                                        />
                                    ) : response.mood == 'suggestie' ? (
                                        <img
                                            alt={response.mood}
                                            src="/img/ideeSVG.svg"
                                        />
                                    ) : (
                                        <img
                                            alt={response.mood}
                                            src="/img/vraagSVG.svg"
                                        />
                                    )}
                                    {response.text}
                                </blockquote>
                            )}
                            <div
                                className={
                                    s['responseItem__triangle_left']
                                }></div>
                        </div>

                        {/* Will only create response block if the owner responded */}

                        {response.clientResponse && (
                            <>
                                <div className={s['responseItem__ownerBlock']}>
                                    <div className={s['responseItem_header']}>
                                        <div
                                            className={s['responseItem__name']}>
                                            {response.clientName}
                                        </div>
                                        <div
                                            className={s['responseItem__date']}>
                                            {customDate(response.updatedAt)}
                                        </div>
                                    </div>

                                    {response.visible ? (
                                        <div
                                            className={
                                                s['responseItem__quote']
                                            }>
                                            <span
                                                className={
                                                    s['responseItem__quote']
                                                }
                                                dangerouslySetInnerHTML={{
                                                    __html: response.clientResponse,
                                                }}
                                            />
                                        </div>
                                    ) : null}

                                    <div
                                        className={
                                            s['responseItem__triangle_right']
                                        }></div>
                                </div>
                            </>
                        )}
                        <hr className={s['responseItem__lineDivider']}></hr>
                    </button>
                    <span
                        className="esri-hide"
                        id={'responsetooltip' + response.id}
                        role="tooltip">
                        {getLanguage === 'nl' ? (
                            <>
                                {response.name ? response.name : 'Iemand'}{' '}
                                plaatste een reactie op{' '}
                                {customDate(response.createdAt)}{' '}
                                {response.locationName &&
                                    'bij lokatie' +
                                        ' ' +
                                        response.locationName}{' '}
                                : {response.text}.{' '}
                                {response.location &&
                                    'Klik om de reactie op de kaart te highlighten.'}
                            </>
                        ) : (
                            <>
                                {response.name ? response.name : 'Someone'}{' '}
                                posted the following response at{' '}
                                {customDate(response.createdAt)}{' '}
                                {response.locationName &&
                                    'on location ' +
                                        ' ' +
                                        response.locationName}{' '}
                                : {response.text}.{' '}
                                {response.location &&
                                    'Click to highlight the response on the map.'}
                            </>
                        )}
                    </span>
                </>
            ) : (
                <span>Deze reactie is verwijderd of bestaat niet</span>
            )}
        </>
    );
}
export default ResponseItem;
